import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    Container: {
      padding: 41,
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: '#fff',
      textAlign: 'left',
      width: '100%',
      height: '100%',
      '&:hover': {
        backgroundColor: '#F8F7FA',
      },
      '& .MuiTypography-h3': {
        width: '50%',
        display: 'block',
        marginLeft: 24,
      },
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      '& > div': {
        display: 'flex',
        alignItems: 'center',
      },
      '& svg': {
        width: 20,
        color: theme.palette.text.secondary,
      },
      // '& button': {
      //   height: 49,
      //     width: 49,
      //     borderRadius: 8,
      //   '&:hover': {
      //     backgroundColor: theme.palette.primary.main,
      //     color: theme.palette.primary.contrastText,

      //   }
      // },
    },
    imageBox: {
      width: 80,
      height: 80,
      borderRadius: 8,

      backgroundColor: theme.palette.primary.light,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    description: {
      color: theme.palette.text.secondary,
      marginTop: 24,
    },
    soon: {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
      borderRadius: 8,
      fontWeight: 'bold',
      fontSize: 14,
      padding: '4px 10.5px',
      marginTop: 24,
    },
  }),
);

export default useStyles;
